import React, { PropsWithChildren } from 'react';

import { Link } from '@opendoor/bricks/core';

const headerHeight = '72px';

interface NavLinkProps {
  href: string;
  active?: boolean;
  name: string;
}

export const NavLink: React.FC<PropsWithChildren<NavLinkProps>> = ({
  children,
  name,
  href,
  active,
}) => (
  <Link
    alignItems="center"
    color="warmgrey950"
    display="inline-flex"
    lineHeight="100"
    fontWeight="medium"
    py={3}
    px={5}
    h={headerHeight}
    analyticsName={`cosmos-landing-page-v2-nav-link-${name}`}
    aria-label="View link"
    href={href}
    aria-current={active}
  >
    {children}
  </Link>
);
